const addUpperCase = (ext: string) => [ext, ext.toUpperCase()];

export const validImageExtensions = ['jpg', 'jpeg', 'png', 'gif'].flatMap(addUpperCase);
export const validAudioExtensions = ['mp3', 'mpeg', 'mp4', 'm4a'].flatMap(addUpperCase);
export const fontAvialableExtentions = ['woff2', 'woff', 'ttf', 'otf'].flatMap(addUpperCase);
